import { createRef } from '@wix/materializer'
import { IPlanner } from './types'

export const createBeckyRef = <StoreValue extends Record<string, Record<string, any>>>(
	planner: IPlanner<StoreValue>,
	path: [keyof StoreValue, keyof StoreValue[keyof StoreValue], ...Array<string>],
	isWeakRef: boolean = false
) =>
	createRef<string>(
		[planner.namespace, ...(path as Array<string>)],
		isWeakRef ? (path[path.length - 1] as string) : undefined
	)
